import React from 'react'

import LogoSVG from '../../images/logo.svg'
import './styles.css'

export default function Logo() {
  return (
    <div className="header__container-logo">
     <LogoSVG className="logo" />
    </div>
  )
}
